import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/index.css';

// Add Electron class to body for platform-specific styling
if (typeof window !== 'undefined' && window.isElectron) {
  document.body.classList.add('is-electron');
  // Detect macOS for traffic light padding
  window.electronAPI?.platform.info().then((info) => {
    if (info.isMac) {
      document.body.classList.add('is-mac-electron');
    }
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
